<template>
  <div
    id="contact-page"
    class="checkout-content wp_AllPageMarginTop"
  >
    <h5 style="text-align:center;"
								data-test="contactUsHeading1"
								id="contactUsHeading1">
      THE NEO BANK
    </h5>
    <!--<h3 style="text-align:left;">-->
      <!--Contact US-->
    <!--</h3>-->
			<p data-test="p-contact-content-1">
				At The NeoBank we strive to meet all of your needs in a timely fashion. We have designed The NeoBank to enable you to do your banking online, and most of your needs will be met within the website. However, upon occasion you may need information that is not addressed on the site. If so, please contact us and an experienced customer service representative will assist you.
			</p>
    <br>
    <p data-test="contactUsHeading2"
							id="contactUsHeading2">
      <b data-test="contactUsHeading2Bold"
									id="contactUsHeading2Bold">
							Customer Contacts:
						</b>
    </p>
    <div class="wp_ContactDetailsFooter">
      <div class="wp_ContactAddressLine"
											data-test="contactUsHeading3"
											id="contactUsHeading3"
											v-for="(address, index) in contactData"
											:key="index"
						>
							<div v-if="address.isEmail === true">
								<span class="ep_AddressEmail"
														data-test="contactUsEmailSpan"
														id="contactUsEmailSpan">
									<b>{{address.header}}:  </b>
									<a :href="address.hrefText"
												data-test="contactUsEmailLink"
												id="contactUsEmailLink">{{address.body}}
      </a></span>
								<br>
								<p>{{address.bodyText}}</p>
							</div>
							<div v-else>
								<b>
									{{address.header}}
								</b>
								<br>
								{{address.body}}
							</div>
							<br>
      </div>
					<div class="wp_ContactDetailsFooter">
						<div class="wp_ContactAddressLine"
											v-for="(address, index) in contactInfo"
											:key="index">
							<b>{{address.header}}</b>
							<br>
							<br>
							<p>{{address.one}},</p>
							<p>{{address.two}},</p>
							<p>{{address.three}},</p>
							<p>{{address.four}}</p>
							<br><br>
						</div>
					</div>
    </div>
  </div>
</template>

<script>
export default {
	data () {
		return {
			contactData: [
				{
					header: 'Banking Services',
					body: '800.545.0289 (Monday-Friday 8am-8pm ET.)',
					isEmail: false
				}, {
					header: 'By Fax',
					body: '302.791.5788',
					isEmail: false
				}, {
					header: 'By Email',
					body: 'info@theneobank.com',
					hrefText: 'mailto:info@theneobank.com',
					isEmail: true
				}, {
					header: 'Prepaid Card Support',
					body: '866.271.1623 (Monday-Friday 8am-8pm ET..)',
					isEmail: false
				}, {
					header: 'By Fax',
					body: '605.988.3346',
					isEmail: false
				}, {
					header: 'By Email',
					body: 'cardoperations@theneobank.com',
					hrefText: 'mailto:cardoperations@theneobank.com',
					bodyText: 'Please remember that information sent to us via email is sent over a non-secure network. Do not include confidential personal information such as account numbers or Social Security Numbers in any non-secure communication.',
					isEmail: true
				}, {
					header: 'By Mail',
					body: 'Listed below are the addresses for you to send your correspondence and deposits. Please send all of your general correspondence to our Customer Service Center and all deposits and loan payments to the addresses provided.',
					isEmail: false
				}
			],
			contactInfo: [
				{
					header: 'Customer Service Center',
					one: 'The Neo Bank',
					two: 'Attn: Customer Service Ctr.',
					three: '409 Silverside Road, Suite 105',
					four: 'Wilmington, DE 19809'
				}, {
					header: 'Deposit Accounts',
					one: 'The Neo Bank',
					two: 'Attn: Deposit Operations',
					three: 'P.O. Box 15329',
					four: 'Wilmington, DE 19809'
				}, {
					header: 'Loan Payments',
					one: 'The Neo Bank',
					two: 'Attn: Loan Payment Ctr.',
					three: '409 Silverside Road, Suite 105',
					four: 'Wilmington, DE 19809'
				}, {
					header: 'Fair Credit Billing Act *',
					one: 'The Neo Bank',
					two: 'Attn: Consumer Credit Dept.',
					three: '409 Silverside Road, Suite 105',
					four: 'Wilmington, DE 19809'
				}
			]
		}
	}
}
</script>

<style lang="scss">
#contact-page {
  font-family: "Nunito Sans", sans-serif;
  text-align: justify;
  padding: 35px;
  padding-top: 70px;
}
</style>
